import { classes } from "lib/actions/util";
import React, { PropsWithChildren } from "react";

const SidePanelSection = ({
  className,
  children,
  ...rest
}: PropsWithChildren<React.HTMLAttributes<{}>>) => {
  return (
    <div
      {...rest}
      className={classes("flex w-[380px] flex-col px-4", className)}
    >
      {children}
    </div>
  );
};

export default SidePanelSection;
